import States from 'ContentUtils/constants/States';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
export const DRAFT_STATES = StateStatusGroups[States.DRAFT];
export const PUBLISHED_STATES = StateStatusGroups[States.PUBLISHED];
export const StateGroups = Object.freeze({
  PUBLISHED_PAGES: 'PUBLISHED_PAGES',
  DRAFT_PAGES: 'DRAFT_PAGES',
  TEMPLATES: 'TEMPLATES',
  SYSTEM: 'SYSTEM',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE'
});